// import Vue from 'vue';
import * as Vue from 'vue';
import App from './src/App.vue';
import router from './src/app-routes.js';
import mitt from 'mitt';
const emitter = mitt();
/**
 * Mount the Vue instance on the DOM element "#wp-vue-app" in the Custom Page Template
 */

const app = Vue.createApp(App);
app.config.globalProperties.emitter = emitter;
app.use(router);
app.mount('#wp-vue-app');
// createApp(App).use(router).mount('#wp-vue-app');